(function () {
  'use strict';

  function submitLocalizationInBackground(form, option) {
    var input = form.querySelector('input[name="locale_code"], input[name="country_code"]');
    if (!input) return;

    input.value = option.getAttribute('data-value');
    form.setAttribute('method', 'post');
    form.setAttribute('action', '/localization');

    var returnTo = form.querySelector('input[name="return_to"]');
    if (returnTo && !returnTo.value) {
      returnTo.value = window.location.pathname + window.location.search;
    }

    var data = new FormData(form);

    fetch('/localization', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      redirect: 'follow'
    })
      .then(function (response) {
        var destination = new URL(response.url, window.location.origin);

        if (
          destination.origin !== window.location.origin ||
          /\/localization\/?$/.test(destination.pathname)
        ) {
          throw new Error('Invalid localization redirect');
        }

        window.location.replace(destination.href);
      })
      .catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var option = target.closest('form.localization-form[action$="/localization"] [data-value]');
      if (!option) return;

      var form = option.closest('form.localization-form');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (option.getAttribute('aria-current') === 'true') return;

      submitLocalizationInBackground(form, option);
    },
    true
  );
})();
